import styled from 'styled-components';

export const Wrapper = styled.div`
  & button[type] {
    width: 210px;
  }
`;

export const IconWrapper = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  height: 32px;
  width: 32px;

  & > svg {
    object-fit: contain;
  }
`;
